import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  Loading,
  InputCustom,
  SelectCustom,
  TextArea,
  HttpError,
  SelectWithSearch,
  Base64Input
} from "../../components"
import { LoadModalWithLabel } from "../modais"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { ToastContainer, ToastMessage } from "react-toastr"
class DistratoForm extends Component {
  constructor() {
    super()
    this.getInitialFieldsEdit = this.getInitialFieldsEdit.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeLocalPublicacao = this.onChangeLocalPublicacao.bind(this)
    this.onChangeData = this.onChangeData.bind(this)
    this.onChangeDataPublicacao = this.onChangeDataPublicacao.bind(this)
    this.onChangeGestor = this.onChangeGestor.bind(this)
    this.onChangeTipo = this.onChangeTipo.bind(this)
    this.onChangeMotivo = this.onChangeMotivo.bind(this)
    this.getInitialFields = this.getInitialFields.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.getJsonDataForContratoId = this.getJsonDataForContratoId.bind(this)
    this.state = {
      tipo: "",
      contrato: "",
      gestor: "",
      data: "",
      publicacao: "",
      localPublicacao: "",
      motivo: "",
      arquivo: "",
      arquivoFileName: "",
      notificacao: "",
      notificacaoFileName: "",
      showForm: false,
      contratos: [],
      gestores: [],
      tipos: []
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Distrato atualizado com sucesso"
    } else {
      message = "Distrato cadastrado com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    if (this.props.isEditing) {
      this.getInitialFieldsEdit()
    } else {
      this.getInitialFields()
    }
  }
  getInitialFieldsEdit() {
    ApiHelper.getEditFieldsDistrato(
      this.props.match.params.id,
      (fields, error) => {
        if (fields) {
          this.setState(
            {
              showForm: true,
              contratos: fields.contratos,
              tipos: fields.tipos,
              gestores: fields.gestores
            },
            () => {
              this.fillFields(fields.distrato)
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  getInitialFields() {
    ApiHelper.getCreateFieldsDistrato((fields, error) => {
      if (fields) {
        this.setState(
          {
            contratos: fields.contratos,
            tipos: fields.tipos,
            gestores: fields.gestores,
            showForm: true
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  getJsonDataForContratoId(id) {
    return this.state.contratos.filter(contrato => {
      return contrato.value === id
    })[0]
  }
  fillFields(fields) {
    var currentFields = {
      tipo: fields.tipo_id,
      contrato: this.getJsonDataForContratoId(fields.contrato_id),
      gestor: fields.gestor_id,
      data: fields.data,
      publicacao: fields.publicacao,
      localPublicacao: fields.local_publicacao,
      motivo: fields.motivo,
      arquivoFileName: fields.arquivo,
      notificacaoFileName: fields.notificacao,
      showForm: true
    }
    this.setState(currentFields)
  }
  onChangeContrato(value) {
    this.setState({
      contrato: value
    })
  }
  sendForm(event) {
    event.preventDefault()
    var parameters = {
      tipo_id: this.state.tipo !== "" ? this.state.tipo : undefined,
      contrato_id:
        this.state.contrato !== "" ? this.state.contrato.value : undefined,
      gestor_id: this.state.gestor !== "" ? this.state.gestor : undefined,
      data: this.state.data !== "" ? Util.dateOnly(this.state.data) : undefined,
      publicacao:
        this.state.publicacao !== ""
          ? Util.dateOnly(this.state.publicacao)
          : undefined,
      local_publicacao:
        this.state.localPublicacao !== ""
          ? this.state.localPublicacao
          : undefined,
      motivo: this.state.motivo !== "" ? this.state.motivo : undefined,
      arquivo: this.state.arquivo !== "" ? this.state.arquivo : undefined,
      notificacao:
        this.state.notificacao !== "" ? this.state.notificacao : undefined
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateDistrato(
        parameters,
        this.props.match.params.id,
        errors => {
          this.toggleLoadModal()
          if (errors) {
            this.showErrorMessage()
            this.handleErrors(errors)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBack()
            })
          }
        }
      )
    } else {
      ApiHelper.createNewDistrato(parameters, errors => {
        this.toggleLoadModal()
        if (errors) {
          this.showErrorMessage()
          this.handleErrors(errors)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBack()
          })
        }
      })
    }
  }
  onChangeNotificacao(files) {
    var base64 = files.base64.split("data:" + files.type + ";base64,").join("")
    this.setState({
      notificacao: base64,
      notificacaoFileName: files.name,
      notificacaoError: ""
    })
  }
  onChangeArquivo(files) {
    var base64 = files.base64.split("data:" + files.type + ";base64,").join("")
    this.setState({
      arquivo: base64,
      arquivoFileName: files.name,
      arquivoError: ""
    })
  }
  onChangeData(value) {
    this.setState({
      data: value,
      dataError: ""
    })
  }
  onChangeDataPublicacao(value) {
    this.setState({
      publicacao: value,
      publicacaoError: ""
    })
  }
  onChangeLocalPublicacao(event) {
    var newValue = event.target.value
    this.setState({
      localPublicacao: newValue,
      local_publicacaoError: ""
    })
  }
  onChangeTipo(event) {
    var newValue = event.target.value
    this.setState({
      tipo: newValue,
      tipo_idError: ""
    })
  }
  onChangeGestor(event) {
    var newValue = event.target.value
    this.setState({
      gestor: newValue,
      gestor_idError: ""
    })
  }
  onChangeMotivo(event) {
    var newValue = event.target.value
    this.setState({
      motivo: newValue,
      motivoError: ""
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    var spanStyle = {
      maxWidth: "100%",
      wordWrap: "break-word"
    }
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div>
          <div className="card">
            <ToastContainer
              ref={input => {
                this.container = input
              }}
              toastMessageFactory={this.toastFactory}
              className="toast-top-right"
              preventDuplicates={true}
            />
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">
                {this.props.isEditing ? "Editar distrato" : "Novo distrato"}
              </h4>
              <p className="category">
                {this.props.isEditing
                  ? "Editar distrato"
                  : "Criar novo distrato"}
              </p>
            </div>
            <div className="card-content">
              <form>
                {this.state.showForm === false ? (
                  <div className="row">
                    <Loading />
                  </div>
                ) : (
                  <div>
                    <div className="row">
                      <SelectWithSearch
                        error={this.state.contrato_idError}
                        sizeClass="col-md-8"
                        options={this.state.contratos}
                        label="Contrato"
                        placeholder="Selecione um contrato"
                        onChange={this.onChangeContrato}
                        value={this.state.contrato}
                      />
                    </div>
                    {this.state.contrato !== "" && (
                      <div>
                        <div className="row">
                          <InputCustom
                            sizeClass="col-md-5"
                            label="Número do contrato"
                            type="text"
                            disabled="disabled"
                            value={this.state.contrato.label.split(" - ")[0]}
                          />
                        </div>
                        <div className="row">
                          <TextArea
                            sizeClass="col-md-11"
                            subTitle="Descrição do contrato"
                            label="Objeto do contrato"
                            disabled="disabled"
                            value={this.state.contrato.label.split(" - ")[1]}
                          />
                        </div>
                        <div className="row">
                          <InputCustom
                            error={this.state.dataError}
                            sizeClass="col-md-3"
                            label="Data do distrato"
                            type="date"
                            onChange={this.onChangeData}
                            value={this.state.data}
                          />
                          <SelectCustom
                            error={this.state.gestor_idError}
                            sizeClass="col-md-3"
                            options={this.state.gestores}
                            label="Assinado pelo gestor"
                            onChange={this.onChangeGestor}
                            value={this.state.gestor}
                          />
                        </div>
                        <div className="row">
                          <InputCustom
                            error={this.state.publicacaoError}
                            sizeClass="col-md-3"
                            label="Data da publicação"
                            type="date"
                            onChange={this.onChangeDataPublicacao}
                            value={this.state.publicacao}
                          />
                          <InputCustom
                            error={this.state.local_publicacaoError}
                            sizeClass="col-md-3"
                            label="Local da publicação"
                            type="text"
                            onChange={this.onChangeLocalPublicacao}
                            value={this.state.localPublicacao}
                          />
                          <SelectCustom
                            error={this.state.tipo_idError}
                            sizeClass="col-md-3"
                            options={this.state.tipos}
                            label="Tipo de distrato"
                            onChange={this.onChangeTipo}
                            value={this.state.tipo}
                          />
                          {this.state.tipo === 2 && (
                            <div className="col-md-2 text-center">
                              <Base64Input
                                ref={ref => (this.upload = ref)}
                                style={{ display: "none" }}
                                multiple={false}
                                onDone={this.onChangeNotificacao.bind(this)}
                              />
                              <button
                                onClick={e => this.upload.click()}
                                type="button"
                                className="btn btn-danger btn-simple btn-xs"
                              >
                                Digitalizar notificação
                                <i className="material-icons">file_upload</i>
                              </button>
                              <br />
                              {this.props.isEditing &&
                              this.state.notificacao === "" ? (
                                <a
                                  target="_blank"
                                  href={this.state.notificacaoFileName}
                                  style={spanStyle}
                                  className="label label-inverse"
                                >
                                  {this.state.notificacaoFileName}
                                </a>
                              ) : (
                                <span
                                  style={spanStyle}
                                  className="label label-inverse"
                                >
                                  {this.state.notificacaoFileName}
                                </span>
                              )}
                              <br />
                              <span
                                style={spanStyle}
                                className="label label-danger"
                              >
                                {this.state.notificacaoError}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <TextArea
                            error={this.state.motivoError}
                            sizeClass="col-md-11"
                            subTitle="Motivo do distrato"
                            label="Motivo"
                            onChange={this.onChangeMotivo}
                            value={this.state.motivo}
                          />
                        </div>
                        <div className="row text-center">
                          <div className="col-md-12">
                            <Base64Input
                              ref={ref => (this.uploadArquivo = ref)}
                              style={{ display: "none" }}
                              multiple={false}
                              onDone={this.onChangeArquivo.bind(this)}
                            />
                            <button
                              onClick={e => this.uploadArquivo.click()}
                              type="button"
                              className="btn btn-danger btn-simple btn-xs"
                            >
                              Digitalizar arquivo de distrato (Opcional)
                              <i className="material-icons">file_upload</i>
                            </button>
                            <br />
                            {this.props.isEditing &&
                            this.state.arquivo === "" ? (
                              <a
                                target="_blank"
                                href={this.state.arquivoFileName}
                                style={spanStyle}
                                className="label label-inverse"
                              >
                                {this.state.arquivoFileName}
                              </a>
                            ) : (
                              <span
                                style={spanStyle}
                                className="label label-inverse"
                              >
                                {this.state.arquivoFileName}
                              </span>
                            )}
                            <br />
                            <span
                              style={spanStyle}
                              className="label label-danger"
                            >
                              {this.state.arquivoError}
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <button
                            onClick={this.sendForm}
                            type="submit"
                            className="btn btn-primary pull-left"
                            data-background-color="as-blue"
                          >
                            {this.props.isEditing ? "Salvar" : "Criar"}
                          </button>
                          <div className="clearfix" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(DistratoForm)



// WEBPACK FOOTER //
// ./src/views/modais/DistratoForm.js